import React from 'react';
import useChannels from '@/hooks/useChannels';
import { useWidgetUIStore } from '@/hooks/useWidgetUIStore';
import { ChannelOptions } from '@/types/widgetConfig';
import GeneralChannelDetail from './GeneralChannelDetail';
import TwilioSmsChannelDetail from './TwilioSmsChannelDetail';
import type { ChannelDetailProps } from './types';

const ChannelDetail: React.FC<ChannelDetailProps> = ({
  onMinimize,
  onContinue,
  onBack,
  className = '',
}) => {
  const { currentChannelDetailType } = useWidgetUIStore();

  const { channelInfo } = useChannels({
    channelType: currentChannelDetailType as keyof ChannelOptions,
  });

  if (channelInfo?.type === 'twilioSms') {
    return <TwilioSmsChannelDetail onBack={onBack} onMinimize={onMinimize} />;
  }

  return (
    <GeneralChannelDetail
      onContinue={onContinue}
      onMinimize={onMinimize}
      onBack={onBack}
      className={className}
    />
  );
};

export default ChannelDetail;
